<template>
  <div>
    <p>Selección la acción que se realizará sobre el dispositivo</p>
    <validation-provider
      :name="$t('commands.device_action_panel.action')"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block small mb-25">
        {{ label }}
      </label>
      <v-select
        v-model="model"
        :options="actionOptions"
        :clearable="true"
        label="text"
        :reduce="option => option.value"
        @input="$emit('input', model)"
      />
      <p v-if="errors.length" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
    <p class="mt-1 small" v-if="config.subtype === 'panel_device_action'">
      Si el dispositivo no es compatible con la acción se ejecutará la acción equivalente.
    </p>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";

const PANEL_ACTIONS = ["SENSOR_RESET", "ALARM_SILENCE"];
const DEVICE_ACTIONS = ["RESTORE", "RESET", "BYPASS", "ARM", "DISARM"];

export default {
  name: "PanelDeviceAction",
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    config: Object,
  },
  data() {
    return {
      model: null,
    };
  },
  created() {
    this.model = this.value || null;
  },
  computed: {
    label() {
      if (this.config.subtype === "panel_device_action") {
        return 'Acción sobre el dispositivo';
      }

      return 'Acción sobre el panel';
    },
    actionOptions() {

      if (this.config.subtype === "panel_action") {
        return PANEL_ACTIONS.map(value => ({
          text: value,
          value,
        }));
      }

      return DEVICE_ACTIONS.map(value => ({
        text: value,
        value,
      }));
    },
  },
};
</script>

<style></style>
